import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TeamModel} from "../../models/team.model";

@Injectable({providedIn: 'root'})
export class TeamsHttpService {

  private base_url = `/teams`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getTeams(params?: any): Observable<{ cursor: string, list: TeamModel[] }> {
    return this.http
      .get<{ cursor: string, list: TeamModel[] }>(this.base_url, {params});
  }

  getTeamsAgentIds(teamIds) {
    return this.http
      .get<any>(this.base_url + '/agentIds', {
        params: {
          teamIds
        }
      });
  }


}
